const getFileError = ({ accepted, rejections }) => {
  if (accepted && !rejections.length) {
    if (accepted.errors.length) {
      const firstError = accepted.errors[0];
      return `${firstError.message} at line ${firstError.row}`;
    }

    if (accepted.data.length === 1) {
      return 'file has only headings';
    }
  }

  if (
    !accepted &&
    rejections.length === 1 &&
    rejections[0].errors.some(({ code }) => code === 'file-invalid-type')
  ) {
    return 'file must be a CSV';
  }

  if (rejections.length > 1 || (rejections.length === 1 && accepted)) {
    return 'too many files';
  }

  return accepted ? null : 'invalid file';
};

export default getFileError;
